var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    {
      staticStyle: { "flex-wrap": "nowrap" },
      attrs: { row: "", "justify-end": "" }
    },
    [
      _c(
        "v-btn",
        {
          staticClass: "ma-0 mr-2",
          attrs: { "x-small": "", icon: "", text: "", color: _vm.approveColor },
          on: {
            click: function($event) {
              $event.stopPropagation()
              return _vm.$emit("approve")
            }
          }
        },
        [_c("v-icon", [_vm._v("assignment_turned_in")])],
        1
      ),
      _vm._v(" "),
      !_vm.isTaskBlocked
        ? _c(
            "v-btn",
            {
              staticClass: "ma-0",
              attrs: {
                "x-small": "",
                icon: "",
                text: "",
                color: _vm.rejectColor
              },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.$emit("reject")
                }
              }
            },
            [_c("v-icon", [_vm._v("content_paste_off")])],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-116d1081", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-116d1081","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FieldManagement/FieldWork/Data/TaskDecisionButtons.vue
// module id = null
// module chunks = 